module.exports = "<div class=\"bottom-bar\">\n  <a class=\"transparent-button long\" style='margin-right: 10px' [routerLink]='previous'><b>PREVIOUS</b></a>\n  <a class=\"red-button long\" style='margin-left: 10px' [routerLink]='next' *ngIf='nextEnabled'><b>NEXT</b></a>\n  <a class=\"red-button long\" style='margin-left: 10px' (click)='showError()' *ngIf='!nextEnabled'><b>NEXT</b></a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/onboarding/components/company-setup/bottom-bar/bottom-bar.component.html
// module id = ./src/app/onboarding/components/company-setup/bottom-bar/bottom-bar.component.html
// module chunks = main